import { render } from "./HeaderPersonal.vue?vue&type=template&id=10796e66&scoped=true"
import script from "./HeaderPersonal.vue?vue&type=script&lang=js"
export * from "./HeaderPersonal.vue?vue&type=script&lang=js"

import "./HeaderPersonal.vue?vue&type=style&index=0&id=10796e66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10796e66"]])

export default __exports__